import { useMemo } from "react";
import {
  ReportPhotoContent,
  type ReportImageAttachment,
  type ReportPhotoLayout,
} from "../pathologist-review/ReportPhotoContent";
import {
  ReportAttachmentPage,
  type ReportFooterProps,
  type ReportHeaderSectionProps,
} from "./ReportAttachmentPage";

export type { ReportImageAttachment } from "../pathologist-review/ReportPhotoContent";

interface ReportImagePageProps {
  image: ReportImageAttachment;
  url?: string;
  failed?: boolean;
  onLoadError?: (imageId: string) => void;
  onRetry?: (imageId: string) => void;
  photoReferenceWidth?: string;
  headerSectionProps?: ReportHeaderSectionProps;
  footerProps?: ReportFooterProps;
}

export function ReportImagePage({
  image,
  url,
  failed,
  onLoadError,
  onRetry,
  photoReferenceWidth,
  headerSectionProps,
  footerProps,
}: ReportImagePageProps) {
  const layout = useMemo<ReportPhotoLayout>(
    () => ({ maxHeight: 600, width: photoReferenceWidth || "100%" }),
    [photoReferenceWidth]
  );

  return (
    <ReportAttachmentPage
      headerSectionProps={headerSectionProps}
      footerProps={footerProps}
      imageContent
    >
      <ReportPhotoContent
        image={image}
        url={url}
        failed={failed}
        onLoadError={onLoadError}
        onRetry={onRetry}
        layout={layout}
      />
    </ReportAttachmentPage>
  );
}
